module.exports = __webpack_public_path__ + "static/media/laya-healthcare.0d630d78.png";